import type { SVGProps } from "react";

export default function DisableRoundingIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5972 8.73611C12.5972 7.77728 11.8199 7 10.8611 7C9.90229 7 9.125 7.77728 9.125 8.73611V12.2083C9.125 13.1672 9.90229 13.9444 10.8611 13.9444C11.8199 13.9444 12.5972 13.1672 12.5972 12.2083V8.73611Z"
        stroke="currentColor"
        strokeWidth="1.38889"
      />
      <path
        d="M6 13.9443H6.34722"
        stroke="currentColor"
        strokeWidth="1.38889"
        strokeLinecap="round"
      />
      <path
        d="M4 5.5L17 14.5"
        stroke="currentColor"
        strokeWidth="1.38889"
        strokeLinecap="round"
      />
    </svg>
  );
}
